import {
  GET_ACL_SUCCESS,
  UPDATE_ACL_SUCCESS,
  CLEAR_ACL,
  LOGOUT_COMPLETE,
  GET_ACCESS_INSIGHTS_SUCCESS,
  SHARED_RESOURCES_ACL_SUCCESS,
} from '../../constants/actionTypes';

let initialState = {
  byKey: {},
};

export const aclReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACL_SUCCESS:
    case UPDATE_ACL_SUCCESS:
      return saveAcl(state, action);

    case SHARED_RESOURCES_ACL_SUCCESS:
      return saveSharedResourcesInfo(state, action);

    case GET_ACCESS_INSIGHTS_SUCCESS:
      return saveAccessRules(state, action);

    case CLEAR_ACL:
    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function saveAcl(state, action) {
  const key = action.requestInfo.aclResourceType + action.requestInfo.id;

  return {
    ...state,
    byKey: {
      ...state.byKey,
      [key]: action.result,
    },
  };
}

function saveSharedResourcesInfo(state, action) {
  const key = action.requestInfo.userId;

  return {
    ...state,
    sharedResources: {
      [key]: action.result,
    },
  };
}

function saveAccessRules(state, action) {
  const { resourceType, id, userId } = action.requestInfo;
  const key = `${resourceType}_${id}_${userId}`;

  return {
    ...state,
    effectiveRules: {
      [key]: action.result.effective_rule,
    },
    accessRules: {
      [key]: action.result.applicable_rules,
    },
  };
}
